import {IResizeData, StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {BonusBunniesGameConfig} from "../../BonusBunniesGameConfig";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {BonusBunniesParsedInitData} from "../../server/data/BonusBunniesParsedInitData";
import {BonusBunniesGameMode} from "../../gamemode/BonusBunniesGameMode";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {BonusBunniesSoundConfig} from "../../BonusBunniesSoundConfig";
import {Linear, TimelineLite, TweenLite} from "gsap";
import {BaseView} from "@nolimitcity/slot-game/bin/core/base/BaseView";
import {BonusBunniesBonusMultiplierWPCountUp} from "./countup/BonusBunniesBonusMultiplierWPCountUp";

/**
 * Created by Jerker Nord on 2019-09-05.
 */

export class BonusBunniesBonusMultiplierWPView extends BaseView {

    private _multiplierText:BonusBunniesBonusMultiplierWPCountUp;
    private _multiplierBackground:PIXI.Sprite;
    private _multiplierContainer:PIXI.Container;
    private _extraReelActivated:boolean = false;
    private static MULTIPLIER_CONTAINER_LANDSCAPE_POSITION:PIXI.Point = new PIXI.Point(694, 50);
    private static MULTIPLIER_CONTAINER_PORTRAIT_POSITION:PIXI.Point = new PIXI.Point(520, -66);
    private static MULTIPLIER_CONTAINER_EXTRA_REEL_OFFSET:number = 150;
    private static MULTIPLIER_TEXT_OFFSET:PIXI.Point = new PIXI.Point(80, 74);
    private _isRestore:boolean;
    private _restoreMultiplier:number;
    private _multiplierUpdateEffect:TimelineSprite;
    private _currentMultiplierValue:number = 0;
    private _initAnimationsComplete:boolean = false;
    private _orientation:string;
    private _radioLight:PIXI.spine.Spine;

    constructor() {
        super();
        StageManager.getLayer(BonusBunniesGameConfig.instance.LAYERS.BASE_FEATURE.name).addChild(this);
        this.addEventHandlers();
    }

    private addEventHandlers():void {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:BonusBunniesParsedInitData):void {
        if(data.isRestoreState == true && data.mode == BonusBunniesGameMode.BONUS_GAME) {
            this._isRestore = true;
            this.checkRestore();
        }
        this._restoreMultiplier = data.totalBonusWinMultiplierBefore;
    }

    private checkRestore():void {
        //Making sure correct values are set even if GFX are created before init response
        if(this._initAnimationsComplete == true && this._isRestore == true) {
            this._isRestore = false;
            this.initMultiplierText(this._restoreMultiplier);
        }
    }

    protected initAnimations():void {
        this._multiplierContainer = new PIXI.Container();
        this._multiplierContainer.visible = false;
        this.addChild(this._multiplierContainer);

        this._multiplierBackground = new PIXI.Sprite(GameResources.getTextures("multipler_board")[0]);
        this._multiplierContainer.addChild(this._multiplierBackground);

        this._radioLight = new PIXI.spine.Spine(GameResources.getSpineAsset("Radiolight"));
        this._radioLight.position.set(78, 70);
        this._radioLight.visible = false;
        this._multiplierContainer.addChild(this._radioLight);

        this._multiplierText = new BonusBunniesBonusMultiplierWPCountUp(BonusBunniesGameConfig.TEXT_STYLES.MULTIPLIER_COUNTER_BITMAP_STYLE);
        this._multiplierText.position = BonusBunniesBonusMultiplierWPView.MULTIPLIER_TEXT_OFFSET;
        this._multiplierText.init();
        this._multiplierContainer.addChild(this._multiplierText);

        this._multiplierUpdateEffect = new TimelineSprite(GameResources.getTextures("multiplierUpdateEffect"));
        this._multiplierUpdateEffect.position.set(-20, -26);
        this._multiplierUpdateEffect.blendMode = PIXI.BLEND_MODES.SCREEN;
        this._multiplierUpdateEffect.hide();
        this._multiplierContainer.addChild(this._multiplierUpdateEffect);

        this._initAnimationsComplete = true;
        this.checkRestore();
    }

    protected onResize(resizeData:IResizeData):void {
        this._orientation = resizeData.orientation;
        this.setOrientationPosition();
    }

    private setOrientationPosition():void {
        if(this._orientation == Orientation.LANDSCAPE) {
            this._multiplierContainer.position = BonusBunniesBonusMultiplierWPView.MULTIPLIER_CONTAINER_LANDSCAPE_POSITION;
        } else {
            this._multiplierContainer.position = BonusBunniesBonusMultiplierWPView.MULTIPLIER_CONTAINER_PORTRAIT_POSITION;
        }
        if(this._extraReelActivated == true) {
            this._multiplierContainer.position.x += BonusBunniesBonusMultiplierWPView.MULTIPLIER_CONTAINER_EXTRA_REEL_OFFSET;
        }
    }

    public initMultiplierText(bonusWinMultiplier:number):void {
        if(this._restoreMultiplier && this._restoreMultiplier > 0) {
            this.setText(this._restoreMultiplier, this._restoreMultiplier, false);
            this._restoreMultiplier = 0;
        } else {
            this.setText(bonusWinMultiplier, bonusWinMultiplier, true);
        }
        this.setOrientationPosition();
        this._multiplierContainer.visible = true;
    }

    public setTextChestPump(multiplierValue:number):void {
        this._currentMultiplierValue = multiplierValue;
        this._radioLight.updateTransform();
        this._radioLight.visible = true;
        this._multiplierText.getCountUpAnimation(false, multiplierValue, multiplierValue, 2, 1);
        this._radioLight.state.setAnimation(0, "base", false);
        const scaleUpTL:TimelineLite = new TimelineLite();
        scaleUpTL.add(() => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_MULTIPLIER_UPDATE));
        scaleUpTL.add(new TweenLite(this._multiplierText.scale, 0.2, {x : 2, y : 2, ease : Linear.easeNone}));
        scaleUpTL.add(new TweenLite(this._multiplierText.scale, 0.2, {x : 1, y : 1, ease : Linear.easeNone}));
    }

    public setText(from:number, to:number, playSound:boolean = true):TimelineLite {
        const countUpTL:TimelineLite = new TimelineLite();
        if(to == this._currentMultiplierValue) {
            return countUpTL;
        }
        let duration:number = 0.01;
        if(to - from > 3) {
            duration = 2;
        }
        this._currentMultiplierValue = to;

        if(duration > 0) {
            if(to - from > 10) {
                countUpTL.add(this._multiplierText.getCountUpAnimation(false, from, to, duration, 1));
                countUpTL.add(() => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_MULTIPLIER_UPGRADE_LOOP), "-=" + (duration - 0.2));
            } else {
                countUpTL.add(this._multiplierText.getCountUpAnimation(playSound, from, to, duration, 1));
            }
            countUpTL.add(new TweenLite(this._multiplierText.scale, 0.2, {x : 1.8, y : 1.8, ease : Linear.easeNone}));
            countUpTL.add([
                this._multiplierUpdateEffect.getAnimationAutoShowHide(),
                () => SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_MULTIPLIER_UPDATE),
                new TweenLite(this._multiplierText.scale, 0.2, {x : 1, y : 1, ease : Linear.easeNone})
            ]);
        } else {
            countUpTL.add([
                new TweenLite(this._multiplierText.scale, 0.2, {x : 1.8, y : 1.8, ease : Linear.easeNone}),
            ]);
            countUpTL.add([
                this._multiplierUpdateEffect.getAnimationAutoShowHide(),
                () => {
                    if(playSound == true) {
                        SlotGame.sound.playEffect(BonusBunniesSoundConfig.instance.BONUS_MULTIPLIER_UPDATE);
                    }
                },
                new TweenLite(this._multiplierText.scale, 0.2, {x : 1, y : 1, ease : Linear.easeNone}),
                this._multiplierText.getCountUpAnimation(playSound, from, to, duration, 1)
            ]);
        }
        return countUpTL;
    }

    public abortText(from:number, to:number, isAborted:boolean):void {
        if(isAborted == true) {
            this._multiplierText.scale.set(1, 1);
            SlotGame.sound.stopEffect(BonusBunniesSoundConfig.instance.BONUS_MULTIPLIER_UPGRADE_LOOP);
        }
        this._multiplierText.abort(to, isAborted);
        this._multiplierUpdateEffect.hide();
    }

    public hideWinText():void {
        this._multiplierContainer.visible = false;
        this._multiplierText.getCountUpAnimation(false, 1, 1, 0.1, 1);
        this._extraReelActivated = false;
        this._multiplierContainer.position = BonusBunniesBonusMultiplierWPView.MULTIPLIER_CONTAINER_LANDSCAPE_POSITION;
        this._radioLight.visible = false;
    }

    set extraReelActivated(value:boolean) {
        if(value == true && this._extraReelActivated == false) {
            this._multiplierContainer.position.x += BonusBunniesBonusMultiplierWPView.MULTIPLIER_CONTAINER_EXTRA_REEL_OFFSET;
        }
        this._extraReelActivated = value;
    }

    get currentMultiplierValue():number {
        return this._currentMultiplierValue;
    }
}